import React from "react"
import Layout from "../../components/Layout/index"
import { useState, useEffect } from 'react'
import AdminService from '../../services/admin/AdminService';
import OwnerTable from '../../components/Tables/owner_table'
import DriverInfo from "../../components/Tables/driver_manage_info"
import Conformation from "../../components/common/conformation"
import CarInfo from "../../components/common/car_info_model"
import OwnerInformation from './ownerInfo'
import { sideBarItems } from '../../utils';
import _ from 'lodash';
import { Pagination } from "../../components/common/pagination";
import OwnerSearch from "../../components/OwnerSearch";
import { CSVLink } from "react-csv";
import { FaDownload } from "react-icons/fa";
import { toast } from 'react-hot-toast';

// TODO: Filter Search is caching some items and showing wrong data.

const Owners = ({ history, location }) => {
  const [owners, setOwners] = useState([]);
  const [filteredOwners, setFilteredOwners] = useState([]);
  const [searchQuery, setSearchQuery] = useState({});
  const [showOwnerInfo, setShowOwnerInfo] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [ownerInfo, setOwnerInfo] = useState(null);
  const [carInfo, setCarInfo] = useState();
  const [isedit, setIsedit] = useState(true);

  //this is for pAGINATION HANDLE 
  const query = new URLSearchParams(location.search);
  const [page, setPage] = useState(parseInt(query.get('page')) || 1);
  const [limit, setLimit] = useState(parseInt(query.get('limit')) || 15);
  const [totalPages, setTotalPages] = useState(1);

  const [showpopu, setShowpopu] = useState(true);

  const updateURLParams = (newPage, newLimit) => {
    const params = new URLSearchParams();
    params.set('page', newPage);
    params.set('limit', newLimit);
    history.replace({ search: params.toString() });
  };

  const showpopuSection = () => {
    setShowpopu(true);

  }

  const handleSearchQuery = (type, value) => {
    switch (type) {
      case 'name':
      case 'mobile':
      case 'hasVehicle':
      case 'hasDriver':
      case 'isVerifiedAsOwner':
      case 'division':
      case 'fromDistrict':
      case 'vehicleType':
      case 'vehicleSeats':
      case 'carRegistrationStartDate':
      case 'carRegistrationEndDate':
      case 'model':
      case 'year':
        if (value && value !== 'all') {
          setSearchQuery(prev => ({ ...prev, [type]: value }));
        } else {
          setSearchQuery(prev => {
            const newQuery = { ...prev };
            delete newQuery[type];
            return newQuery;
          });
        }
        break;
      default:
        break;
    }
  }

  const clearSearch = () => {
    setSearchQuery({});
    setPage(1);
  }

  // useEffect(() => {
  //   if (_.isEmpty(searchQuery)) {
  //     initApi();
  //   }
  // }, [searchQuery])

  const searchOwner = () => {
    console.log("searchQuery", searchQuery)
    if (searchQuery.carRegistrationStartDate && searchQuery.carRegistrationEndDate) {
      const startDate = new Date(searchQuery.carRegistrationStartDate);
      const endDate = new Date(searchQuery.carRegistrationEndDate);
      
      if (startDate > endDate) {
        toast.error('Start date cannot be greater than end date');
        return;
      }
    }
    setPage(1);
    initApi();
  }


  const ShowOwnerSection = (item) => {
    setShowOwnerInfo(true);
    setOwnerInfo(item);

  }

  useEffect(() => {
    initApi();
  }, [page, limit])

  const initApi = () => {
    AdminService.getOwnersPg(page, limit, searchQuery).then(data => {
      console.log("Data getOwners", data.data.users)
      setOwners(data.data.users);
      setFilteredOwners(data.data.users);
      setTotalPages(data.data.totalPages);
      if (ownerInfo) {
        try {
          const ownerData = data.data.users.filter(item => item._id === ownerInfo._id)
          setOwnerInfo(ownerData[0])
        } catch (e) {
          console.log('Exception', e)
        }
      } else {
        console.log('owner info not available')
      }
    })
  }
  const nextPage = () => {
    if (page < totalPages) {
      const newPage = page + 1;
      setPage(newPage);
      updateURLParams(newPage, limit);
    }
  };
  const prevPage = () => {
    if (page > 1) {
      const newPage = page - 1;
      setPage(newPage);
      updateURLParams(newPage, limit);
    }
  };

  const updateOwnerInfo = (updatedOwner) => {
    const addressUpdate = {
      address: updatedOwner.address
    };
    AdminService.updateProfile(updatedOwner._id, addressUpdate)
      .then(() => {
        console.log("Owner updated successfully!");
        initApi();
      })
      .catch((error) => {
        console.error("Error updating owner:", error);
      });
  };
  const handleChangeSearch = (searchQuery) => {
    if (!searchQuery) {
      setFilteredOwners(owners);
      return;
    }

    let filtered = owners.filter((item) => {
      return (
        (item.mobile && item.mobile.toString().match(new RegExp(searchQuery, "gi"))) ||
        (item.name && item.name.toString().match(new RegExp(searchQuery, "gi"))) ||
        (item._id && item._id.toString().match(new RegExp(searchQuery, "gi")))
      );
    });

    setFilteredOwners(filtered);
  };
  const handleModal = (isVisible) => {
    setVisibleModal(isVisible)
  }
  const showVihicleInfo = (item) => {
    // alert(JSON.stringify(item));
    setVisibleModal(true);
    setCarInfo(item);
  }

  // Update URL when limit changes
  useEffect(() => {
    updateURLParams(page, limit);
  }, [page, limit]);

  const getCSVData = () => {
    const headers = [
      { label: "Name", key: "name" },
      { label: "Mobile", key: "mobile" },
      { label: "Subdistrict", key: "subdistrict" },
      { label: "District", key: "district" },
      { label: "Division", key: "division" },
      { label: "Verification Status", key: "verificationStatus" },
      { label: "Total Vehicles", key: "totalVehicles" },
      { label: "Driver Added", key: "driverAdded" },
      { label: "Car Information", key: "carInformation" }
    ];

    return {
      headers,
      data: filteredOwners.map(owner => {
        const cars = owner?.vehicles || [];

        // Format car details into a table string
        const formatCarTable = (cars) => {
          if (!cars || cars.length === 0) return 'No cars registered';

          // Create table header
          let tableStr = 'Car Details:\n';
          tableStr += 'Status | Brand & Model | Seats | Registration Date\n';
          tableStr += '------------------------------------------------\n';

          // Add each car's information
          cars.forEach((car, index) => {
            const carInfo = car?.vehicle?.carInfo || {};
            const brand = carInfo.brand || '';
            const model = carInfo.model || '';
            const year = carInfo.year || '';
            const status = car?.vehicle?.verifiedStatus === 'verified' ? "✅" : "❌";
            const seats = car?.vehicle?.seats || 'N/A';
            const regDate = car?.vehicle?.createdAt
              ? new Date(car.vehicle.createdAt).toLocaleDateString()
              : 'N/A';

            tableStr += `${status} | ${brand} ${model} ${year} | ${seats} | ${regDate}\n`;
          });

          return tableStr;
        };

        return {
          name: owner.name || '',
          mobile: owner.mobile || '',
          subdistrict: owner?.address?.subDistrict || 'N/A',
          district: owner?.address?.district || 'N/A',
          division: owner?.address?.division || 'N/A',
          verificationStatus: owner?.isVerifiedAsOwner ? "✅" : "❌",
          totalVehicles: owner?.vehicles?.length > 0 ? owner.vehicles.length : 'N/A',
          driverAdded: owner?.drivers?.length > 0 ? "✅" : "❌",
          carInformation: formatCarTable(cars)
        };
      })
    };
  };

  return (
    <Layout
      modal={<CarInfo handleModal={handleModal} ownerInfo={ownerInfo} carInfo={carInfo} />}
      visibleModal={visibleModal}
      handleModal={handleModal}
      handleChangeSearch={handleChangeSearch}
      title={sideBarItems.owner.key}>

      <div className="flex w-full ">
        <div className="w-full">

          <OwnerSearch
            searchQuery={searchQuery}
            handleSearchQuery={handleSearchQuery}
            clearSearch={clearSearch}
            searchOwner={searchOwner}
          />

          <OwnerTable
            owners={filteredOwners}
            // owners={owners}
            ShowOwnerSection={ShowOwnerSection}
            updateOwnerInfo={updateOwnerInfo}
          />
          <div className="flex justify-center items-center mt-6 space-x-4">
            <Pagination
              page={page}
              totalPages={totalPages}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              prevPage={prevPage}
              nextPage={nextPage}
            />
            <CSVLink
              data={getCSVData().data}
              headers={getCSVData().headers}
              filename={`owners-${new Date().toISOString().split('T')[0]}.csv`}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center gap-2"
            >
              <FaDownload /> Download CSV
            </CSVLink>
          </div>
        </div>
        {showOwnerInfo &&
          <Modal onClose={() => setShowOwnerInfo(false)}>
            <OwnerInformation
              ownerInfo={ownerInfo}
              setShowOwnerInfo={setShowOwnerInfo}
              refresh={initApi}
              showVihicleInfo={showVihicleInfo}
              showOwnerInfo={showOwnerInfo}
              updateOwnerInfo={updateOwnerInfo}
            />
          </Modal>
        }
      </div>
    </Layout>
  )
};

const Modal = ({ children, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-40">
    <div className="p-6">
      {children}
    </div>
  </div>
);
export default Owners;
